import React, { useMemo } from 'react'
import { useAuthContext } from '../../context/auth.context'

// fallback: what someone who is not staff sees instead (nothing by default),
// for the addresses that should say "no access" rather than draw a blank page.
export const LoginSysAdmin = ({ children, fallback = null }) => {
  const authContext = useAuthContext()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const show = useMemo(() => authContext.state.isSysRoot || authContext.state.isSysAdmin, [authContext.state])

  return (
    <React.Fragment>
      {show ? children : fallback}
    </React.Fragment>
  )
}
